// extracted by mini-css-extract-plugin
export default {"overridableClass":"conditional_link_overridableClass__uCG3Y"};